import {
  API_ERROR,
  GET_IMPORT_MODELS_LIST,
  GET_IMPORT_MODELS_LIST_SUCCESS,
  GET_EXPORT_MODELS_LIST,
  GET_EXPORT_MODELS_LIST_SUCCESS,
  EXPORT_STATUS,
  EXPORT_STATUS_SUCCESS,
  EXPORT_DOWNLOAD_FILE,
  EXPORT_DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_EXPORT_DATA,
  DOWNLOAD_EXPORT_DATA_SUCCESS,
  IMPORT_UPLOAD_STATUS,
  IMPORT_UPLOAD_STATUS_SUCCESS,
  UPLOAD_IMPORT_DATA,
  UPLOAD_IMPORT_DATA_SUCCESS,
  UPLOAD_TABLE_PREVIEW_DATA,
  UPLOAD_TABLE_PREVIEW_DATA_SUCCESS,
  INPUT_CHANGE_VALUE,
  NEXT_STEP,
  PREV_STEP,
  FINISH_STEP,
  CHANGE_TYPE,
  CLEAR_DATA,
} from "./actionTypes";

const initialState = {
  loading: false,
  exportModelList: [],
  importModelList: [],
  importType: 0,
  exportData: {},
  importData: {},
  importTableColumns: [],
  importValidRowData: [],
  importTableRowData: [],
  submit_ImportData: {},
  currentStep: 0,
  model: false,
  importResponseData: {},
  request_id: null,
  status: "",
  error: "",
};

const importExportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_IMPORT_MODELS_LIST:
    case GET_EXPORT_MODELS_LIST:
    case EXPORT_STATUS:
    case EXPORT_DOWNLOAD_FILE:
    case DOWNLOAD_EXPORT_DATA:
    case IMPORT_UPLOAD_STATUS:
    case UPLOAD_IMPORT_DATA:
    case UPLOAD_TABLE_PREVIEW_DATA:
      return { ...state, loading: true };

    case GET_IMPORT_MODELS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        importModelList: action.payload,
      };

    case GET_EXPORT_MODELS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        exportModelList: action.payload,
      };

    case EXPORT_STATUS_SUCCESS:
    case EXPORT_DOWNLOAD_FILE_SUCCESS:
    case DOWNLOAD_EXPORT_DATA_SUCCESS:
      return { ...state, loading: false };

    case UPLOAD_IMPORT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        request_id: action.payload,
      };

    case IMPORT_UPLOAD_STATUS_SUCCESS:
      const response = action.payload;
      let columns = [];

      if (response !== "Import is still running") {
        if (!response?.has_validation_errors) {
          if (response?.valid_rows?.length > 0) {
            columns = Object.keys(response.valid_rows[0]).map((key) => ({
              key,
              label: key,
            }));
          }
        } else {
          if (response?.invalid_rows?.length > 0) {
            columns = Object.keys(response.invalid_rows[0]).map((key) => ({
              key,
              label: key,
            }));
          }
        }

        return {
          ...state,
          loading: false,
          importType: 1,
          importResponseData: response,
          importTableColumns: columns,
          importTableRowData:
            !response?.has_errors && response?.has_validation_errors
              ? response.invalid_rows
              : response.valid_rows,
        };
      }
      return state;

    case INPUT_CHANGE_VALUE:
      if (action.payload.type === "import") {
        return {
          ...state,
          importData: {
            ...state.importData,
            [action.payload.key]: action.payload.value,
          },
        };
      } else {
        return {
          ...state,
          exportData: {
            ...state.exportData,
            [action.payload.key]: action.payload.value,
          },
        };
      }

    case NEXT_STEP:
      return { ...state, currentStep: state.currentStep + 1 };

    case PREV_STEP:
      return { ...state, currentStep: state.currentStep - 1 };

    case FINISH_STEP:
      return {
        ...state,
        exportData: {},
        importData: {},
        importTableColumns: [],
        importValidRowData: [],
        submit_ImportData: {},
        currentStep: 0,
      };

    case CHANGE_TYPE:
      return { ...state, importType: action.payload };

    case CLEAR_DATA:
      return {
        ...state,
        loading: false,
        exportModelList: [],
        importModelList: [],
        importType: 0,
        exportData: {},
        importData: {},
      };

    case UPLOAD_TABLE_PREVIEW_DATA_SUCCESS:
      let previewColumns = [];
      const importFields = action.payload?.import_fields || [];
      
      const formatColumns = (fields, columns = [], prefix = "") => {
        for (let field of fields) {
          if (field.is_serializer) {
            formatColumns(field.serializer_fields, columns, prefix + field.key + "__");
          } else {
            columns.push({
              key: prefix + field.key,
              label: field.label,
            });
          }
        }
        return columns;
      };

      previewColumns = formatColumns(importFields);
      previewColumns.unshift(
        { key: "import_status", label: "Import Status" },
        { key: "errors", label: "Errors" }
      );

      return {
        ...state,
        currentStep: 1,
        loading: false,
        importType: 2,
        importData: action.payload,
        importTableColumns: previewColumns,
        importTableRowData: action.payload?.data_list || [],
      };

    case API_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default importExportReducer;
